<template>
    <div>
        <!-- Modal Ofertas -->
        <div class="modal fade" id="ofertasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="dados">
                    <div class="modal-header">
                        <h5 class="modal-title">Ofertas</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-for="(ofertas, idx) in linhas" :key="idx" class="card-deck">
                            <div class="card" v-for="(oferta, iox) in ofertas" :key="iox">
                                <div class="card-header d-flex justify-content-between">
                                    <div class="lead">
                                        {{ oferta.st_titulo }}
                                    </div>
                                    <div>
                                        <span class="badge badge-primary">
                                            {{ oferta.items.length }}
                                        </span>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <span v-html="oferta.st_info" v-if="oferta.fl_info_html"></span>
                                    <span v-else style="white-space: pre-wrap;">{{ oferta.st_info }}</span>
                                </div>
                                <div class="card-footer d-flex justify-content-between">
                                    <button type="button" class="btn btn-success" @click="incluir_oferta(oferta)">
                                        Incluir
                                    </button>
                                    <div>
                                        <span v-for="(item, iix) in oferta.items" :key="iix" class="badge badge-primary ml-1">
                                            {{ item.procedimento.st_sigla }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {
    data() {
        return { 
            dados: null, 
        }
    },

    computed: { 
        linhas: function () { 
            let lista = ( this.dados && this.dados.ofertas && this.dados.ofertas.lista ? this.dados.ofertas.lista : [] );
            return _.chunk(lista, 2);
        }
    },

    methods: { 
        abrir (marcacao) { 
            this.dados = _.cloneDeep(marcacao);
            $('#ofertasModal').modal('show');
        },

        fechar_modal () { 
            $('#ofertasModal').modal('hide');
        },

        incluir_oferta (oferta) { 
            if ( !confirm ("Confirma a inclusão da oferta '" + oferta.st_titulo + "'?") ) { 
                return; 
            }

            this.$util.atualizar(this, { 
                service: 'ofertas', 
                func: 'incluir_oferta',
                dados: { 
                    id_marcacao: this.dados.id_marcacao,
                    id_oferta_particular: oferta.id_oferta_particular
                },
                modal: 'ofertasModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }

    }

}
</script>

